import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "./AddUser.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import CameraRetroIcon from "@rsuite/icons/legacy/CameraRetro";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { TbEyeClosed } from "react-icons/tb";
import { VscEye } from "react-icons/vsc";
import { RiLockPasswordLine } from "react-icons/ri";
import { getItemToken } from "../../../Utils/localStorageUtils";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import { toast } from "react-toastify";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import { currentIpAddressDetails } from "../../../components/CommonMethod/CommonMethods";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";

import {
  CitySelect,
  CountrySelect,
  GetCity,
  GetCountries,
  GetState,
  StateSelect,
} from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import { IoMdInformationCircle } from "react-icons/io";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import { useMyContext } from "../../../components/Provider/CommonProvider";

function AddUser() {
  const { fetchRequest, globalImageUplaodAPI } = useMyContext()
  const { id } = useParams()
  const navigate = useNavigate();
  const [countryid, setCountryid] = useState(0);
  const [stateid, setstateid] = useState(0);
  const [cityid, setCityid] = useState(0);
  const isEdit = Boolean(id);

  const handleWorld = (name, value) => {
    setEditUser({ ...editUser, [name]: value });
  }

  const normalizeRegionValue = (value) => String(value || "").trim().toLowerCase();

  const getSelectedPhoneCountry = () => {
    if (editUser?.ccode_unique?.includes(",")) {
      return editUser.ccode_unique.split(",")[0]?.toLowerCase();
    }

    if (editUser?.country && defaultData?.country?.length) {
      const matchedCountry = defaultData.country.find(
        (item) => item?.country_name?.toLowerCase() === editUser.country?.toLowerCase()
      );
      if (matchedCountry?.sortname) return matchedCountry.sortname.toLowerCase();
    }

    return "in";
  };
  const nameRef = useRef(null)
  const lastnameRef = useRef(null)
  const emailRef = useRef(null)
  const profileRef = useRef(null)
  const passwordRef = useRef(null)
  const mobileRef = useRef(null)
  const codeRef = useRef(null)
  const roleRef = useRef(null)

  const userAccessToken = getItemToken('access_token');
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [profileImageFile, setProfileImageFile] = useState('');
  const [editUserError, setEditUserError] = useState({})
  const [passwordType, setPasswordType] = useState("password");
  const [showOverlay, setShowOverlay] = useState(false);
  const [domReload, setDomReload] = useState(false)
  const [defaultData, setDefaultData] = useState([])
  const [customFieldValues, setCustomFieldValues] = useState({});
  const [editUser, setEditUser] = useState({
    username: "",
    last_name: "",
    name: "",
    email: "",
    password: "",
    mobile: "",
    avatar: "",
    role: "",
    ccode: "",
    active: 0,
    city: "",
    state: "",
    country: "",
    dob: "",
    gender: "",
  });
  const [ipDetails, setIpDetails] = useState(null)
  const [signupMenu, setSignupMenu] = useState(0);
  const access_token = localStorage.getItem("access_token");
  const headers = {
    Authorization: "Bearer " + access_token,
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  const combinedRef = useRef({
    permission_id: null,
  });

  const [isPasswordChanged, setIsPasswordChanged] = useState(false);

  const togglePassword = () => {
    setPasswordType(prevType => (prevType === "password" ? "text" : "password"));
  };

  const handleInput = (e) => {
    const { name, type, value, checked } = e.target;

    if (type === "checkbox") {
      setEditUser((prevEditUser) => ({
        ...prevEditUser,
        [name]: checked ? 1 : 0
      }));
    }
    if (type === "text" || type == "number" || type == "email" || type == "date") {
      if ((name === "username" || name === "last_name") && /\d/.test(value)) {
        return;
      }
      setEditUser((prevEditUser) => ({
        ...prevEditUser,
        [name]: value || "",
      }));
    }
    if (type === 'select-one') {
      setEditUser((prev) => ({
        ...prev,
        [name]: value,
      }));
      setEditUserError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
    if (name === "password") {
      setIsPasswordChanged(true);
    }

    setEditUserError((prevEditUserError) => ({
      ...prevEditUserError,
      [name]: '',
    }));
  };

  const fetchData = async () => {
    await axios.get(`${process.env.REACT_APP_Baseurl}/admin/users/create`, { headers: userAccessToken, })
      .then((response) => {
        // toast.success(response?.data?.message)
        setDefaultData((prev) => ({
          ...prev,
          role: response?.data?.role,
          country: response?.data?.country,
          gender: response?.data?.gender,
          adminPermission: response?.data?.permission,
          partnerPermission: response?.data?.partnerPermission
        }))
        setSignupMenu(response.data.signupmenu);

      })
      .catch((error) => toast.error(error?.response?.data?.message));

    await axios.get(`${process.env.REACT_APP_Baseurl}/admin/subscription/index`, { headers: userAccessToken, })
      .then((response) => {
        setDefaultData((prev) => ({
          ...prev,
          subscriptionPlans: response?.data?.AllSubscriptionPlan,
        }))
      })
      .catch((error) => console.log(error));

  }
  const getUser = async () => {
    setShowOverlay(true)
    const reqData = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/users/edit/${id}`, { headers: userAccessToken });
    if (reqData?.data?.status) {
      const user = reqData?.data?.user;
      setShowOverlay(false)

      const formattedDob = user?.DOB
        ? new Date(user?.DOB).toISOString().slice(0, 10)
        : "";

      setEditUser({
        ...user,
        dob: formattedDob,
        mobile: user?.mobile || '',
        password: '',
        confirmPassword: ''
      });

      setDefaultData((prev) => ({
        ...prev,
        activeCurrency: reqData?.data?.activeCurrency,
      }));
    }
  };

  const handleImageChange = async (event) => {
    const { files, name } = event.target;
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];
    setEditUserError((prev) => ({
      ...prev,
      [name]: "",
    }));
    if (!files?.[0]) return;
    const selected = files[0];
    if (!allowedTypes.includes(selected.type)) {
      setEditUserError((prev) => ({
        ...prev,
        [name]: "Only JPG, JPEG, WEBP and PNG files are allowed.",
      }));
      setProfileImageFile(null);
      return;
    }
    if (files?.length > 0) {
      const newFile = files[0];
      const reader = new FileReader();
      const readFile = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        });
      };
      const fileContent = await readFile(newFile);
      setProfileImageFile(newFile);
      setEditUserError((editUserError) => ({
        ...editUserError,
        'image': '',
      }));
    }
    else {
    }
  };

  const validatePassword = (pwd) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    return regex.test(pwd);
  };

  const formValidation = () => {
    let formIsValid = true;
    const nameRegex = /^[A-Za-z\s]+$/;

    if (signupMenu?.username === 1) {
      if (!editUser?.username) {
        setEditUserError((prevFormData) => ({
          ...prevFormData,
          username: "User Name cannot be empty.",
        }));
        nameRef.current?.focus();
        formIsValid = false;
      } else if (/\d/.test(editUser?.username)) {
        setEditUserError((prev) => ({
          ...prev,
          username: "User Name should not contain numbers.",
        }));
        nameRef.current?.focus();
        formIsValid = false;
      } else {
        setEditUserError((prev) => ({ ...prev, username: "" }));
      }

      if (!editUser?.last_name) {
        setEditUserError((prevFormData) => ({
          ...prevFormData,
          last_name: "Last Name cannot be empty.",
        }));
        lastnameRef.current?.focus();
        formIsValid = false;
      } else if (/\d/.test(editUser?.last_name)) {
        setEditUserError((prev) => ({
          ...prev,
          last_name: "Last Name should not contain numbers.",
        }));
        lastnameRef.current?.focus();
        formIsValid = false;
      } else {
        setEditUserError((prev) => ({ ...prev, last_name: "" }));
      }
    } else {
      setEditUserError((prev) => ({ ...prev, username: "", last_name: "" }));
    }

    if (signupMenu?.email === 1) {
      const normalizedEmail = editUser.email?.toLowerCase().trim();
      if (!normalizedEmail) {
        setEditUserError((prevFormData) => ({ ...prevFormData, email: "Email cannot be empty" }));
        emailRef.current?.focus();
        formIsValid = false;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(normalizedEmail)) {
        setEditUserError((prevFormData) => ({
          ...prevFormData,
          email: "Invalid email address"
        }));
        emailRef.current?.focus();
        formIsValid = false;
      } else {
        setEditUserError((prevFormData) => ({ ...prevFormData, email: "", }));
        setEditUser((prevUser) => ({
          ...prevUser,
          email: normalizedEmail,
        }));
      }
    } else {
      setEditUserError((prevFormData) => ({ ...prevFormData, email: "" }));
    }

    if (signupMenu?.password === 1) {
      if (!id && !editUser?.password) {
        setEditUserError(prevFormData => ({
          ...prevFormData,
          password: "Passwords cannot be empty.",
        }));
        passwordRef.current?.focus();
        formIsValid = false;
      }
      else if (!id && editUser?.password?.length < 8) {
        setEditUserError(prevFormData => ({
          ...prevFormData,
          password: "Password must be at least 8 characters long.",
        }));
        passwordRef.current?.focus();
        formIsValid = false;
      }
      else if (!id && !validatePassword(editUser?.password)) {
        setEditUserError(prevFormData => ({
          ...prevFormData,
          password: "Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, a number, and a special character.",
        }));
        passwordRef.current?.focus();
        formIsValid = false;
      } else {
        setEditUserError(prevFormData => ({ ...prevFormData, password: "" }));
      }
    } else {
      setEditUserError(prevFormData => ({ ...prevFormData, password: "" }));
    }

    if (signupMenu?.mobile === 1) {
      if (!editUser?.ccode) {
        setEditUserError((prevFormData) => ({
          ...prevFormData,
          ccode: "Code cannot be empty.",
        }));
        codeRef.current?.focus();
        formIsValid = false;
      } else {
        setEditUserError((prevFormData) => ({ ...prevFormData, ccode: "" }));
      }
    } else {
      setEditUserError((prevFormData) => ({ ...prevFormData, ccode: "" }));
    }

    if (!editUser?.role) {
      setEditUserError((prevFormData) => ({
        ...prevFormData,
        role: "User Role cannot be empty.",
      }));
      roleRef.current?.focus();
      formIsValid = false;
    }

    if (editUser?.role === "1" || editUser?.role === "4") {
      if (!editUser?.permission_id) {
        setEditUserError((prevFormData) => ({
          ...prevFormData,
          permission_id: "Permission cannot be empty.",
        }));
        combinedRef.current['permission_id']?.focus();
        formIsValid = false;
      }
    }
    return formIsValid;
  };

  const handleImageUpload = async (userId) => {
    const imageFormData = new FormData();
    const modelName = "User";
    imageFormData.append("user_id", userId);
    imageFormData.append("avatar", profileImageFile);
    imageFormData.append("id", userId);
    imageFormData.append("modelName", modelName);
    imageFormData.append('imageFields[]', 'avatar')
    if (profileImageFile) {
      try {
        const imageApi = globalImageUplaodAPI()
        const res = await fetchRequest({ method: "POST", url: imageApi, data: imageFormData });
        const newAvatarUrl = res?.data?.avatar || res?.avatar || res?.data?.data?.avatar;
        if (newAvatarUrl) {
          setEditUser((prev) => ({
            ...prev,
            avatar: newAvatarUrl,
          }));
        }
      } catch (err) {
        console.error("Image upload failed", err);
      }
    }
  };

  const handleSubmit = async () => {
    setShowOverlay(true)
    try {
      const formData = {
        ...editUser,
        ccode: `${editUser?.ccode}`,
      };
      const res = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/users/store`, formData, { headers: userAccessToken })
      if (res?.data?.status) {
        try {
          const { saveCustomFieldsConditional } = await import('../../../CustomFields/conditionalCustomFieldsWrapper');
          const cfRes = await saveCustomFieldsConditional(
            process.env.REACT_APP_Baseurl,
            userAccessToken,
            'user',
            res?.data?.user?.id,
            customFieldValues
          );
          if (!cfRes?.data?.status) throw new Error(cfRes?.data?.message || 'Failed to save additional fields');
        } catch (e) {
          toast.error(e?.response?.data?.message || e.message || 'Failed to save additional fields');
          setShowOverlay(false);
          return;
        }
        await handleImageUpload(res?.data?.user.id)
        toast.success(res?.data?.message)
        setShowOverlay(false)
        navigate("/users");
      }
      else {
        setShowOverlay(false)
        toast.error(res?.data?.message + "  Email Already has been taken!")
      }
    }
    catch (err) {
      setShowOverlay(false)
      toast.error(err?.response?.data?.message)
    }
  }

  const handleUpdate = async () => {
    setShowOverlay(true);
    try {
      let formData = {
        id: editUser?.id,
        username: editUser?.username,
        last_name: editUser?.last_name,
        email: editUser?.email,
        ccode: `${editUser?.ccode}`,
        mobile: editUser?.mobile,
        role: editUser?.role,
        active: editUser?.active,
        permission_id: editUser?.permission_id,
        payment_plans_id: editUser?.payment_plans_id,
        country: editUser?.country,
        state: editUser?.state,
        city: editUser?.city,
        dob: editUser?.dob,
        gender: editUser?.gender,
      };

      if (isPasswordChanged && editUser?.password !== "*******") {
        formData.password = editUser?.password;
      } else {
        formData.password = ""; // Send empty string if not changed
      }

      await axios.post(`${process.env.REACT_APP_Baseurl}/admin/users/update/${id}`, formData, {
        headers: userAccessToken
      }).then(async (res) => {
        if (res?.data?.status) {
          // save custom field values (strict)
          try {
            const { saveCustomFieldsConditional } = await import('../../../CustomFields/conditionalCustomFieldsWrapper');
            const cfRes = await saveCustomFieldsConditional(
              process.env.REACT_APP_Baseurl,
              userAccessToken,
              'user',
              id,
              customFieldValues
            );
            if (!cfRes?.data?.status) throw new Error(cfRes?.data?.message || 'Failed to save additional fields');
          } catch (e) {
            toast.error(e?.response?.data?.message || e.message || 'Failed to save additional fields');
            setShowOverlay(false);
            return;
          }
          handleImageUpload(id);
          toast.success(res?.data?.message);
          setShowOverlay(false);
          setDomReload(!domReload);
          setProfileImageFile(null);
          setEditUserError((prev) => ({}))
        } else {
          toast.error(res?.data?.message + " Email Already has been taken!");
          setShowOverlay(false);
        }
      }).catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong!");
        setShowOverlay(false);
      });
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong!");
      setShowOverlay(false);
    }
  };

  const handleValidate = async (e) => {
    e.preventDefault()
    if (formValidation()) {
      if (!id) {
        handleSubmit()
      }
      else {
        handleUpdate()
      }
    }
    else {
      console.log("Form validation failed ");
    }
  }

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);

    const dateOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };

    const timeOptions = {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true // AM/PM format
    };

    const formattedDate = date.toLocaleDateString('en-US', dateOptions);
    const formattedTime = date.toLocaleTimeString('en-US', timeOptions);

    return (
      <>{formattedDate}</>
    );
  }

  const handlePlan = (planid) => {
    setEditUser((prevEditUser) => ({
      ...prevEditUser,
      'payment_plans_id': planid,
    }));
  }
  const handleClearSelectFile = (value) => {
    setProfileImageFile(null)
    setEditUserError((prev) => ({
      ...prev,
      [value]: ""
    }))

  }

  useEffect(() => {
    const initData = async () => {
      if (id) {
        await getUser();
      }
      await fetchData();
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-source`,
          {
            headers: headers,
            params: { source: "add-users" },
          }
        );
        setLabelDisplay(response?.data?.label_management || []);
      } catch (error) {
        console.error("Error fetching label display:", error);
      }
    };
    initData();
  }, [domReload]);
  useEffect(() => {
    const fetchCCode = async () => {
      if (!editUser?.ccode && defaultData?.country) {
        try {
          const res = await currentIpAddressDetails();
          if (res) {
            const matchingCounties = defaultData?.country?.filter(
              (item) => item?.sortname === res?.country_code
            )[0]?.phonecode;

            setEditUser((prev) => ({
              ...prev,
              ccode: matchingCounties,
              ccode_unique: `${res?.country_code},${matchingCounties}`,
            }));
          } else {
            toast.error('Failed to retrieve IP address details.');
          }
        } catch (error) {
          console.error("Error in fetchCCode:", error);
        }
      }
    };
    fetchCCode();
  }, [editUser?.ccode, defaultData?.country]);

  useEffect(() => {
    if (editUser?.ccode && defaultData?.country && !editUser?.ccode_unique) {
      let match = defaultData.country.find(c => c.id == editUser.country || c.id == countryid);
      if (!match || (isEdit ? `+${match.phonecode}` : `${match.phonecode}`) !== editUser.ccode) {
         match = defaultData.country.find(c => (isEdit ? `+${c.phonecode}` : `${c.phonecode}`) === editUser.ccode);
      }
      if (match) {
         const phoneCode = isEdit ? `+${match.phonecode}` : `${match.phonecode}`;
         setEditUser(prev => ({ ...prev, ccode_unique: `${match.sortname},${phoneCode}` }));
      }
    }
  }, [editUser?.ccode, defaultData?.country, isEdit, countryid, editUser?.country, editUser?.ccode_unique]);

  useEffect(() => {
    const syncRegionIds = async () => {
      if (!isEdit || !editUser?.country) return;

      try {
        const countries = await GetCountries();
        const normalizedCountry = normalizeRegionValue(editUser?.country);
        const backendCountryMatch = defaultData?.country?.find((item) => (
          normalizeRegionValue(item?.country_name) === normalizedCountry ||
          normalizeRegionValue(item?.sortname) === normalizedCountry ||
          normalizeRegionValue(item?.id) === normalizedCountry
        ));

        const matchedCountry = countries?.find((item) => (
          normalizeRegionValue(item?.name) === normalizedCountry ||
          normalizeRegionValue(item?.sortname) === normalizedCountry ||
          normalizeRegionValue(item?.id) === normalizedCountry ||
          (backendCountryMatch && (
            normalizeRegionValue(item?.name) === normalizeRegionValue(backendCountryMatch?.country_name) ||
            normalizeRegionValue(item?.sortname) === normalizeRegionValue(backendCountryMatch?.sortname)
          ))
        ));

        if (!matchedCountry) return;
        setCountryid(matchedCountry.id);

        if (editUser?.state) {
          const states = await GetState(matchedCountry.id);
          const normalizedState = normalizeRegionValue(editUser?.state);
          const matchedState = states?.find((item) => (
            normalizeRegionValue(item?.name) === normalizedState ||
            normalizeRegionValue(item?.id) === normalizedState
          ));

          if (matchedState) {
            setstateid(matchedState.id);

            if (editUser?.city) {
              const cities = await GetCity(matchedCountry.id, matchedState.id);
              const normalizedCity = normalizeRegionValue(editUser?.city);
              const matchedCity = cities?.find((item) => (
                normalizeRegionValue(item?.name) === normalizedCity ||
                normalizeRegionValue(item?.id) === normalizedCity
              ));

              if (matchedCity) {
                setCityid(matchedCity.id);
              }
            }
          }
        }
      } catch (error) {
        console.error("Error syncing region ids:", error);
      }
    };

    syncRegionIds();
  }, [isEdit, editUser?.country, editUser?.state, editUser?.city, defaultData?.country]);

  return (
    <>
      {showOverlay && <Response_Processing></Response_Processing>}
      {<AdminBackNavigation path={`${'/users'}`} text="Back" />}
      <AdminSaveHeader heading={id ? `${labelDisplay?.[13]?.title}` : `${labelDisplay?.[0]?.title}`} saveText={id ? `${labelDisplay?.[12]?.title}` : `${labelDisplay?.[12]?.title}`} saveMethod={handleValidate} type="submit" />
      <form onSubmit={handleValidate}  >
        <FormContainer>
          <LeftWrapper>
            <Wrapper>
              <MessageHeading text={id ? editUser?.username : `${labelDisplay?.[1]?.title}`} />
              {signupMenu.username === 1 && (
                <>
                  <MessageLabel text={labelDisplay?.[2]?.title} className="mandatorySimple" />
                  <AdminCustomInput type="text" id="username" name="username" value={editUser?.username} placeHolder={"Enter user name"} ref={nameRef} onChange={handleInput} error={editUserError?.username} />

                  <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
                  <AdminCustomInput type="text" id="last_name" name="last_name" value={editUser?.last_name} placeHolder={"Enter last name"} ref={lastnameRef} onChange={handleInput} error={editUserError?.last_name} />
                </>
              )}
              {signupMenu.email === 1 && (
                <>
                  <MessageLabel text={labelDisplay?.[4]?.title} className="mandatorySimple" />
                  <AdminCustomInput type="email" id="email" name="email" value={editUser?.email} placeHolder={"Enter email address"} ref={emailRef} onChange={handleInput} error={editUserError?.email} />
                </>
              )}
              {signupMenu.password === 1 && (
                <>
                  <MessageLabel text={labelDisplay?.[5]?.title} className="mandatorySimple" />

                  <div className="position-relative">
                    <input
                      type={passwordType}
                      name="password"
                      value={isPasswordChanged ? editUser?.password : ""}
                      onChange={(e) => {
                        if (e.target.value.trim() !== "") {  // Check if user is actually typing
                          setIsPasswordChanged(true);
                        }
                        setEditUser(prev => ({ ...prev, password: e.target.value }));
                        setEditUserError((prev) => ({ ...prev, "password": "" }))
                      }}
                      ref={passwordRef}
                      autoComplete="new-password" // Prevents autofill
                      placeholder="Enter Password"
                      className={`rs-input py-3 px-5 form-control-lg custom-placeholder custom-input-border theme-text-color mb-3 custom-input ${editUserError?.password ? 'custom-input-error' : ''}`}
                    />

                    <button onClick={togglePassword} type="button" className="position-absolute passWordIcon bg-transparent">
                      {passwordType === "password" ? <TbEyeClosed className="eyeClosed  text-dark" /> : <VscEye className="eyeOpen  text-dark" />}
                    </button>
                    <RiLockPasswordLine className="lockIcon position-absolute text-dark" />
                    {editUserError?.password &&
                      <div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={editUserError?.password} classname='errorred d-block' /></div>
                    }
                  </div>
                </>
              )}

              {signupMenu.mobile === 1 && (
                <>
                  <MessageLabel text={labelDisplay?.[6]?.title} className="mandatorySimple" />
                  <div className="mb-3 admin-phone-input-wrapper">
                    <PhoneInput
                      country={getSelectedPhoneCountry()}
                      value={`${String(editUser?.ccode || "").replace("+", "")}${editUser?.mobile || ""}`}
                      onChange={(value, countryData) => {
                        const dialCode = countryData?.dialCode ? `+${countryData.dialCode}` : "";
                        const mobileNumber = dialCode ? value.slice(countryData.dialCode.length) : value;
                        const countryCode = countryData?.countryCode?.toUpperCase() || "";

                        setEditUser((prev) => ({
                          ...prev,
                          ccode: dialCode,
                          ccode_unique: countryCode ? `${countryCode},${dialCode}` : prev?.ccode_unique,
                          mobile: mobileNumber || "",
                        }));

                        setEditUserError((prev) => ({
                          ...prev,
                          ccode: "",
                          mobile: "",
                        }));
                      }}
                      inputProps={{
                        id: "mobile",
                        name: "mobile",
                        ref: (input) => {
                          mobileRef.current = input;
                          codeRef.current = input;
                        },
                      }}
                      placeholder="Enter mobile number"
                      countryCodeEditable={false}
                      disableSearchIcon
                      enableSearch
                      inputStyle={{ width: "100%" }}
                      inputClass="bg-transparent theme-text-color rounded-0 ownInputFlag admin-phone-input"
                      dropdownClass="theme-bg-color theme-text-color ownInputDropDown"
                      buttonClass="bg-transparent border-0 p-1 ownButtonClass admin-phone-button"
                    />
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="col-12">
                      {editUserError?.ccode && (<MessageBox text={`${editUserError?.ccode}`} classname='errorred mb-2 d-block' />)}
                      {editUserError?.mobile && (<MessageBox text={`${editUserError?.mobile}`} classname='errorred mb-2 d-block' />)}
                    </div>
                  </div>
                </>
              )}

              {signupMenu.DOB === 1 && (
                <>
                  <div className='d-flex position-relative '>
                    <p className="mb-3 mt-2 admin-input-title d-block position-relative"> Date of Birth </p>
                  </div >
                  <AdminCustomInput id={"dob"} min={"1900-01-01"} max={new Date().toISOString().split('T')[0]} type="date" name="dob" value={editUser?.dob} onChange={handleInput} placeHolder={"Date Of Birth "} error={editUserError?.dob} />
                </>
              )}

              {signupMenu.gender === 1 && (
                <>
                  <MessageLabel text={'Gender'} />
                  <select name="gender" value={editUser?.gender} onChange={handleInput} className="form-select mb-3 custom-placeholder   border border-1 theme-border-color  theme-text-color" ref={codeRef}>
                    <option value='' className="theme-bg-color theme-text-color" >Select Gender</option>
                    {defaultData?.gender?.map((item, index) => {
                      return <option key={index} value={`${item?.value}`} className="theme-bg-color theme-text-color">{item?.name}</option>
                    })}
                  </select>
                </>
              )}

            </Wrapper>

            <Wrapper>
              <div className="card p-3 mt-3">
                <FieldRenderer2
                  pageIdentifier={id ? "users.edit" : "users.create"}
                  entityType="user"
                  entityId={id}
                  text="Additional Fields"
                />
                <FieldRenderer
                  pageIdentifier={id ? "users.edit" : "users.create"}
                  entityType="user"
                  entityId={id}
                  onChange={setCustomFieldValues}
                />
              </div>

            </Wrapper>

            <Wrapper>
              <MessageHeading text={labelDisplay?.[8]?.title} />
              <div className="row mx-0">
                <div className="col-9 ps-0">
                  <MessageLabel text={labelDisplay?.[9]?.title} />
                </div>
                <div className="col-3 text-end">
                  <label className="switch">
                    <input name="active" onChange={handleInput} checked={Number(editUser?.active) === 1} type="checkbox" className="rs-input" />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
            </Wrapper>
          </LeftWrapper>
          <RightWrapper>
            {signupMenu.avatar === 1 && (
              <>
                <Wrapper>
                  <MessageHeading text={labelDisplay?.[7]?.title} />
                  <AdminImageUploadZone
                    onChange={handleImageChange}
                    selectedFile={profileImageFile}
                    uploadedImage={editUser?.avatar}
                    onDelete={handleClearSelectFile}
                    ref={profileRef}
                    name="image"
                    id={id}
                    accept="image/jpeg,image/png,image/jpg,image/webp"
                    error={editUserError?.image}
                  />
                </Wrapper>
              </>
            )}

            {signupMenu.region === 1 && (
              <Wrapper>
                <MessageHeading text={'Region'} />
                <div className='d-flex position-relative '>
                  <p className="mb-3 mt-2 admin-input-title d-block position-relative"> Country </p>
                </div >
                <CountrySelect
                  key={`country-${editUser?.country || ''}`}
                  id="country-select"
                  onChange={(e) => {
                    setCountryid(e.id);
                    handleWorld('country', e.name);
                  }}
                  defaultValue={
                    editUser?.country ? { name: editUser.country } : null
                  }
                  placeHolder="Select Country"
                  inputClassName="bg-transparent theme-border-color theme-text-color border-0 country-input"
                  containerClassName="custom-country"
                />

                <div className='d-flex position-relative '>
                  <p className="mb-3 mt-2 admin-input-title d-block position-relative"> State </p>
                </div >

                <StateSelect
                  id="state-select"
                  key={`${countryid}-${editUser?.state || ''}`}
                  countryid={countryid}
                  onChange={(e) => {
                    setstateid(e.id);
                    handleWorld('state', e.name);
                  }}
                  defaultValue={editUser?.state ? { name: editUser.state } : undefined}
                  placeHolder="Select State"
                  inputClassName="bg-transparent theme-text-color border-0 country-input"
                  containerClassName="custom-country"
                />

                <div className='d-flex position-relative '>
                  <p className="mb-3 mt-2 admin-input-title d-block position-relative"> City </p>
                </div >

                <CitySelect
                  id="city-select"
                  key={`${countryid}-${stateid}-${editUser?.city || ''}`}
                  countryid={countryid}
                  stateid={stateid}
                  onChange={(e) => {
                    setCityid(e.id);
                    handleWorld('city', e.name);
                  }}
                  defaultValue={editUser?.city ? { name: editUser.city } : undefined}
                  placeHolder="Select City"
                  inputClassName="bg-transparent theme-text-color border-0 country-input"
                  containerClassName="custom-country"
                />
              </Wrapper>
            )}

            <Wrapper>
              <MessageHeading text={labelDisplay?.[10]?.title} />
              <MessageLabel text={labelDisplay?.[11]?.title} className="mandatorySimple" />
              <select name="role" value={editUser?.role} onChange={handleInput}
                className={`rs-input w-100 form-control-lg bg-transparent custom-placeholder theme-text-color mb-3 custom-input custom-input-border ${editUserError?.role ? 'custom-input-error' : ''}`}
                ref={roleRef}>
                {!id && <option value='' className="theme-bg-color theme-text-color" >&nbsp;Select Role</option>}
                {defaultData?.role?.filter((item) => [1, 2, 3].includes(item?.id))?.map((item, index) => {
                  return <option key={item?.id} value={item?.id} className="theme-bg-color theme-text-color">&nbsp;{item?.role_name}</option>
                })}
              </select>
              {editUser?.role === "1" || editUser?.role === "4" ?
                <>
                  <AdminCustomSelect name="permission_id" value={editUser?.permission_id} onChange={handleInput} ref={(el) => (combinedRef.current.permission_id = el)} options={editUser?.role === "1" ? defaultData?.adminPermission?.map((item) => ({ name: item?.role_name, value: item?.id })) : editUser?.role == "4" ? defaultData?.partnerPermission?.map((item) => ({ name: item?.role_name, value: item?.id })) : []} error={editUserError?.permission_id} defaultOptionName={"Choose an permission"} />
                </> : ""}
              {editUserError?.role && (
                <div className="d-flex align-items-start gap-2">
                  <IoMdInformationCircle className="errorred" style={{ width: "17px", height: "16px" }} />
                  <MessageBox text={editUserError?.role} classname="errorred d-block" />
                </div>
              )}
              {editUser?.role == 3 && <div className="d-flex align-items-center flex-wrap ">
                {defaultData?.subscriptionPlans?.map((item, index) =>
                  <div key={index} className={`p-3 w-100 shadow rounded-4 mb-4  ${item?.plan_id == editUser?.payment_plans_id ? "theme-button-bg-color theme-button-text-color" : ""}`} onClick={() => handlePlan(item?.plan_id)}>
                    <div className="d-flex align-items-center justify-content-between">
                      <p className="planPriceText">{defaultData?.activeCurrency?.symbol} {item?.price}</p>
                      <p>{item?.type}</p>
                    </div>
                    <p className=""> {item?.plans_name?.charAt(0).toUpperCase() + item?.plans_name?.slice(1)}</p>
                    <p className="fw-bold mb-2">Plan Details</p>
                    <div className="col-12 p-2">
                      <div className="theme-bg-color-secondary theme-text-color rounded-3 p-4 shadow-sm">
                        <div className="d-flex mb-2">
                          <div style={{ width: "150px" }}><strong>Billing Interval</strong></div>
                          <div>-</div>
                          <div className="ms-auto">{item?.billing_interval?.charAt(0).toUpperCase() + item?.billing_interval?.slice(1)}</div>
                        </div>
                        <div className="d-flex mb-2">
                          <div style={{ width: "150px" }}><strong>Quality</strong></div>
                          <div>-</div>
                          <div className="ms-auto">{item?.video_quality}</div>
                        </div>
                        <div className="d-flex">
                          <div style={{ width: "150px" }}><strong>Devices Allowed</strong></div>
                          <div>-</div>
                          <div className="ms-auto">{item?.devices || 0}</div>
                        </div>
                      </div>
                    </div>

                    <p className="fw-bold mb-2">Note</p>
                    <div dangerouslySetInnerHTML={{ __html: item?.plan_content }} />
                  </div>)}
              </div>}
            </Wrapper>
          </RightWrapper>

        </FormContainer>
        <AdminCustomButton saveMethod={handleValidate} saveText={id ? `${labelDisplay?.[12]?.title}` : `${labelDisplay?.[12]?.title}`} type='submit' className='d-block ms-auto' />
      </form>
    </>
  );
}
export default AddUser;
